<template>
  <!-- We need form because or-confirm "confirm" button has type="submit" and it submits a form. Remove it if or-confirm changes -->
  <form @submit.prevent="">
    <or-button
      class="delete-button"
      buttonType="button"
      :loading="isDeleting"
      icon="delete"
      type="secondary"
      icon-position="left"
      @click="$refs['delete-model-confirm'].open()"
    >
      {{ $t('model.common.delete-model-button.deleteButtonTitle') }}
    </or-button>
    <or-confirm
      ref="delete-model-confirm"
      type="danger"
      confirm-button-text="Delete"
      :title="modalTitle"
      :close-on-confirm="false"
      :loading="isDeleting"
      @confirm="$emit('delete')"
    >
      {{ $t('model.common.delete-model-button.deleteConfirmation.description') }}
    </or-confirm>
  </form>
</template>

<script>
export default {
  props: {
    modalTitle: String,
    isDeleting: Boolean
  }
}
</script>
<style lang="scss" scoped>
  .delete-button {
    border-color: transparent !important;
    padding: 0;
  }
  ::v-deep {
    .ui-icon.delete {
      font-size: 16px;
    }
  }
</style>
